//#region src/components/job-progress/job-progress-state.ts
var e = class {
	static icons = {
		queued: {
			status: "to-do",
			label: "Queued"
		},
		awaiting: {
			status: "needs-attention",
			label: "Awaiting approval"
		},
		done: {
			status: "completed",
			label: "Completed"
		},
		issues: {
			status: "needs-attention",
			label: "Completed with issues"
		},
		failed: {
			status: "failed",
			label: "Failed"
		},
		canceled: {
			status: "canceled",
			label: "Canceled"
		}
	};
	static hasControls(e) {
		return e === "queued" || e === "running" || e === "awaiting" || e === "failed";
	}
	static clampProgress(e) {
		return e == null || !Number.isFinite(e) ? null : Math.min(100, Math.max(0, e));
	}
	static prefersReducedMotion = () => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	static subscribeReducedMotion = (e) => {
		if (typeof window > "u" || typeof window.matchMedia != "function") return () => void 0;
		let t = window.matchMedia("(prefers-reduced-motion: reduce)");
		return t.addEventListener("change", e), () => {
			t.removeEventListener("change", e);
		};
	};
};
//#endregion
export { e as JobProgressStateHelper };
